import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardText, CircularProgress } from 'material-ui';
import { Link } from 'react-router-dom';
import { gql, graphql } from 'react-apollo';

const TripAssignmentsQuery = gql`
query TripAssignments_Owners_Query {
  allUsers {
    edges {
      node {
        id,
        firstName,
        lastName,
        assignments,
      }
    }
  }
}
`;

const TripAssignments = ({ data, className }) => {
  if (data.loading) {
    return (<div style={styles.cardStyles}>
      <Card style={styles.progressContainer}>
        <CardHeader title='Trip Assignments' />
        <CircularProgress style={styles.progressIndicator} />
      </Card>
    </div>);
  }

  const { allUsers: { edges: users } } = data;

  return (<Card className={className}>
    <CardHeader
      title='Trip Assignments'
    />
    <CardText>
      <ul>
        {users.map(({ node: { id, firstName, lastName, assignments } }) => {
          if (assignments === 0) {
            return null;
          }
          return (<li style={styles.ListItemStyles} key={id}>
            <Link to={`/trips/?user=${id}`}>{firstName} {lastName[0]}.</Link>
            <span>{assignments}</span>
          </li>);
        })}
      </ul>
    </CardText>
  </Card>);
};

TripAssignments.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string,
};

TripAssignments.defaultProps = {
  className: '',
};

export default graphql(TripAssignmentsQuery)(TripAssignments);

const styles = {
  ListItemStyles: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 16,
    marginTop: 16,
    marginBottom: 16,
  },
  progressContainer: {
    margin: 10,
    position: 'relative',
  },
  progressIndicator: {
    marginLeft: '50%',
    left: -20,
  },
};



// WEBPACK FOOTER //
// /src/components/Widgets/TripAssignments.js